import React, { Fragment } from 'react';
import Bone from '@lightspeed/cirrus-bone';

const ReceiptAddressPlaceholder = () => (
  <Fragment>
    <div className="cr-pv-1 cr-flex cr-justify-center">
      <Bone width="35%" height="1rem" animated={false} />
    </div>
    <div className="cr-pv-1 cr-flex cr-justify-center">
      <Bone width="45%" height="0.75rem" animated={false} />
    </div>
    <div className="cr-pv-1 cr-flex cr-justify-center">
      <Bone width="65%" height="0.75rem" animated={false} />
    </div>
    <div className="cr-pt-2 cr-pb-1 cr-flex cr-justify-center cr-hidden-md-down">
      <Bone width="42%" height="0.75rem" animated={false} />
    </div>
  </Fragment>
);

export default ReceiptAddressPlaceholder;
